import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../../base-api.service';
import {OrdersModelService} from '../../../Models/Purchases/Orders/orders-model.service';
import {OrderStoreForm} from '../../../../Models/Purchases/Orders/order-store.model';
import {OrderStatusDto} from '../../../../Models/Purchases/Orders/order-status.interface';
import {OrderStatusEnum} from '../../../../Shared/Enum/order-status.enum';
import {OrderDto} from '../../../../Models/Purchases/Orders/order.interface';
import {SendOrderEmailStoreForm} from '../../../../Models/Purchases/Orders/send-order-email-store.model';

@Injectable({
  providedIn: 'root'
})
export class OrdersApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: OrdersModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener los pedidos
   *
   */
  public getOrders(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getPedidos', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Obtener el pedido
   *
   */
  public getOrder(params: { id: number, new_function: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getPedido', params, 'post').subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Obtener los productos pendientes
   *
   */
  public getPendingProducts(params: { id: number, id_local: number, id_proveedor: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getProductosPendientes', params, 'post', true).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Añadir pedido
   *
   */
  public setOrder(params: OrderStoreForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setPedido', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Guardar pedido
   *
   */
  public saveOrder(orderID: number, params: { description: string }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall(`supplier/orders/${orderID}`, params, 'patch').subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Crear pedido a partir de una propuesta del asistente, acepta y envía el pedido al proveedor
   *
   */
  public createOrderFromAssistant(orderId: number): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      this.httpCall(`order/${orderId}/accept`, {}, 'patch').subscribe({
        next: () => {
          this.httpCall(`order/${orderId}/send`, {}, 'patch').subscribe({
            next: (response) => {
              resolve(response);
            },
            error: (err: Error) => {
              reject(err);
            }
          });
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Genera un pedido sugerido
   *
   */
  public generateSuggestedOrder(params: { id_local: number, id_pcp: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setPedidoSugerido', params, 'post', true).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Añadir lineas al pedido
   *
   */
  public setLinesOrder(params: OrderDto): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setPedidoLineas', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Guardar la descripción de una línea
   *
   */
  public saveDescriptionLine(params: { id: number, descripcion: string }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setInfoLineaPedido', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Guardar la cantidad de una linea
   *
   */
  public saveLineQuantity(params: { id: number, cantidad: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('order/line/update/quantity', params, 'patch').subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Eliminar línea
   *
   */
  public deleteLine(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('deletePedidoLinea', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Eliminar pedido
   *
   */
  public deleteOrder(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('deletePedido', params, 'post', true).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Cancelar pedido
   *
   */
  public cancelOrder(params: { id: number, cancel_reason: string, notify: boolean }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('cancelOrder', params, 'post').subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Finalizar pedido
   *
   */
  public finishOrder(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('cerrarPedido', params, 'post', true).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Establecer nuevo estado del pedido
   *
   */
  public setNotNecessary(params: { id_tarea: number, id_proveedor: number, done: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setPedidoEstado', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Enviar pedido
   *
   */
  public sendOrder(params: { id: number, descripcion: string }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('enviarPedido', params, 'post', true).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Establecer nuevo estado del pedido
   *
   */
  public setDeliveryDate(params: { id: number, fecha_recepcion_o: string }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('updateDeliveryDate', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Establecer pedido enviado
   *
   */
  public setOrderSent(params: { id_pedido: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setPedidoEnviado', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Enviar emails
   *
   */
  public sendOrderEmail(params: SendOrderEmailStoreForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('sendMailPedidos', params, 'post', true).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Copiar pedido anterior
   *
   */
  public copyPreviousOrder(params: { id_pedido: number; id_pedido_anterior?: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setPedidoAnterior', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Obtener pedidos anteriores
   *
   */
  public getPreviousOrders(params: { id_pedido: number; id_local: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getPedidosAnteriores', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Guarda el nombre de un pedido favorito
   *
   */
  public setOrderPreviousName(params: { id_pedido: number; favorito_nombre: string }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setFavoritoNombre', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Marcar favorito un pedido anterior
   *
   */
  public setPreviousOrderFavorite(params: {
    id_pedido: number;
    favorito: boolean;
    favorito_dias: string[]
  }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setPedidoAnteriorFavorito', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Obtener los estados de un pedido
   *
   */
  getOrdersStatus(): OrderStatusDto[] {
    return [
      {
        id: OrderStatusEnum.pendent,
        nombre: 'CONST.ORDER_STATUS.PENDING'
      },
      {
        id: OrderStatusEnum.finished,
        nombre: 'CONST.ORDER_STATUS.FINISHED'
      },
      {
        id: OrderStatusEnum.sent,
        nombre: 'CONST.ORDER_STATUS.SENT'
      },
      {
        id: OrderStatusEnum.inProcess,
        nombre: 'CONST.ORDER_STATUS.IN_PROCESS'
      },
      {
        id: OrderStatusEnum.partiallyDelivered,
        nombre: 'CONST.ORDER_STATUS.PARTIALLY_DELIVERED'
      },
    ];
  }

}
